import { FieldValues, Path, UseFormRegister } from 'react-hook-form';

import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

import { TCheckboxColors } from './Checkbox';

export const ECheckboxSizes = {
	md: 'MEDIUM',
	lg: 'LARGE',
} as const;

export type TCheckboxSizes = TValueOfStringRecord<typeof ECheckboxSizes>

export interface ICheckboxProps<T extends FieldValues> {
	checked?: boolean;
	classNames?: string;
	color?: TCheckboxColors | string;
	defaultChecked?: boolean;
	disabled?: boolean;
	disabledTooltip?: string;
	isError?: boolean;
	isFilledStyle?: boolean;
	isIndefinite?: boolean;
	isOverflow?: boolean;
	isPropagation?: boolean;
	isUncheckedDisabled?: boolean;
	label?: string;
	lineHeight?: number;
	maxWidthOverflow?: number;
	name: Path<T>;
	onChange?: (checked: boolean, name: string) => void;
	onChangeForTable?: (event: { target: { checked: boolean } }) => void;
	readOnly?: boolean;
	register?: UseFormRegister<T>;
	size?: TCheckboxSizes;
	tags?: string[];
	withUseForm?: boolean;
	isLabelTooltipDisabled?: boolean;
}

